import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Importa o CSS do Font Awesome

// ============================================================================
// LOG DE INICIALIZAÇÃO DO FRONTEND
// ============================================================================

const logEnvironmentInfo = () => {
  const env = process.env.REACT_APP_ENV || "production";
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "não definido";
  const apiUrl = process.env.REACT_APP_API_URL || "não definido";
  const nodeEnv = process.env.NODE_ENV || "production";

  // Extrair nome do projeto Supabase
  const supabaseMatch = supabaseUrl.match(/https:\/\/([a-z0-9]+)\.supabase\.co/);
  const supabaseProject = supabaseMatch ? supabaseMatch[1] : "desconhecido";

  // Determinar se é desenvolvimento, stage ou produção
  let status = "❓ DESCONHECIDO";
  if (supabaseProject === "bbqpsjhhfrnbkgmgyyof") {
    status = "✨ DESENVOLVIMENTO (Novo banco)";
  } else if (supabaseProject === "hdomdsynjhojgsmeujxm") {
    status = "🧪 STAGE (Banco de testes)";
  } else if (supabaseProject === "tmttskzltwmbboyrhwzo") {
    status = "🔒 PRODUÇÃO (Banco original)";
  }

  console.log("\n");
  console.log("%c╔════════════════════════════════════════════════════════════════╗", "color: #4CAF50; font-weight: bold");
  console.log("%c║         🚀 INICIALIZAÇÃO DO FRONTEND - ORTODOXO QUEIJOS        ║", "color: #4CAF50; font-weight: bold");
  console.log("%c╚════════════════════════════════════════════════════════════════╝", "color: #4CAF50; font-weight: bold");
  console.log("");
  console.log(`%c⚙️  AMBIENTE: ${env.toUpperCase()}`, "color: #2196F3; font-weight: bold");
  console.log(`%c📊 NODE_ENV: ${nodeEnv}`, "color: #FF9800");
  console.log("");
  console.log(`%c🗄️  BANCO DE DADOS:`, "color: #9C27B0; font-weight: bold");
  console.log(`   %cSupabase Project: ${supabaseProject}`, "color: #673AB7");
  console.log(`   %cStatus: ${status}`, "color: #673AB7");
  console.log(`   %cURL: ${supabaseUrl}`, "color: #673AB7; font-size: 0.9em");
  console.log("");
  console.log(`%c⚡ CONFIGURAÇÃO:`, "color: #FF5722; font-weight: bold");
  console.log(`   %cAPI URL: ${apiUrl}`, "color: #D84315");
  console.log(`   %cDebug: ${process.env.REACT_APP_DEBUG === "true" ? "✅ HABILITADO" : "❌ DESABILITADO"}`, "color: #D84315");
  console.log(`   %cLog Level: ${process.env.REACT_APP_LOG_LEVEL || "padrão"}`, "color: #D84315");
  console.log("");
  console.log("%c╔════════════════════════════════════════════════════════════════╗", "color: #4CAF50; font-weight: bold");
  console.log("%c║          Frontend pronto para inicializar! ✅                 ║", "color: #4CAF50; font-weight: bold");
  console.log("%c╚════════════════════════════════════════════════════════════════╝", "color: #4CAF50; font-weight: bold");
  console.log("");
};

// Executar log de inicialização
logEnvironmentInfo();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
